/**
 * مصدر الحقيقة الوحيد لمعرّفات Google Analytics 4.
 *
 * ⚠️ ممنوع كتابة أيّ معرّف `G-...` أو Property ID حرفيّاً في أيّ ملفّ آخر —
 * محروس باختبار `src/__tests__/ga4-single-source.test.ts`.
 *
 * للتبديل إلى property جديد: غيّر القيمتين هنا فقط.
 */

/** Measurement ID للستريم الويب (gtag + Measurement Protocol). */
export const GA4_MEASUREMENT_ID = "G-FJPWZ1WPKM";

/** Property ID الرقميّ (GA4 Data API — التقارير السيرفريّة). */
export const GA4_PROPERTY_ID = "332900525";
